<div *ngIf="coupons.length > 0 || displayCreditPreview" class="container p0 clear-fix mb24 container-gallery"
     id="freshpass-perks-container">
    <div class="fp-perks-title mb24 m0">
        <h2 class="fs24-text fw-n"> {{properties.confirmation.YOUR_FRESHPASS_PERKS}}</h2>
    </div>
    <div class="clearfix"></div>
    <div class="container p0">
        <div class="coupon-grid-container flex-wrap mb45">
            <div *ngIf="displayCreditPreview" class="col-12 col-sm-12 col-md-6 col-lg-4 ">
                <app-credit-preview
                        [creditPreviewStatus]="creditPreviewStatus"
                        [isTrialPlan]="isTrialPlan"
                        [userSubscriptionDetails]="userSubscriptionDetails">
                </app-credit-preview>
            </div>
            <ng-container *ngFor="let coupon of coupons; let i = index">
                <ng-template>
                    <div *ngIf="i == 0"
                         class="section-heading product-group sort-by-aisle m0" id="couponGallery-freshPassPerksTitleContainer">
                        <h2 id="couponGallery-freshPassPerksTitle">{{properties.confirmation.FRESHPASS_PERKS}}</h2>
                    </div>
                </ng-template>
                <ng-container *ngIf="i == couponToFocus && i !=0; else doNotFocusCoupon">
                    <app-coupon-item [data]="coupon" appPrefixFocusAndSelect
                                     class="col-12 col-sm-12 col-md-6 col-lg-4 coupon-grid-offer">
                    </app-coupon-item>
                </ng-container>
                <ng-template #doNotFocusCoupon>
                    <app-coupon-item [data]="coupon" class="col-12 col-sm-12 col-md-6 col-lg-4 coupon-grid-offer">
                    </app-coupon-item>
                </ng-template>
            </ng-container>
        </div>
    </div>
</div>
